module.exports = __webpack_public_path__ + "img/160-56ef5a.png";